import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import './index.css';
import App from './App';

//Import Mixpanel SDK
import mixpanel from "mixpanel-browser";
import { identifyFromStorage } from './utils/mixpanel';
import { captureShareRef } from './services/api';

// // Only enable Mixpanel data collection on production environments
const isProduction = ['owl.turing.com', 'app.turing.com'].includes(window.location.hostname);

mixpanel.init('19d09af0675ef2f538f34268d2ce9116', {
  autocapture: isProduction,
  record_sessions_percent: isProduction ? 100 : 0,
  opt_out_tracking_by_default: !isProduction,
});

// Re-identify returning users who already have a session
identifyFromStorage();

// Count a click if this visit came from an account share link (?ref=<code>)
void captureShareRef();


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
